import {ApplicationConfig, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter, withPreloading} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {xTokenInterceptorFn} from '@core/interceptors/http.interceptor';
import {xConfigInterceptorFn} from '@core/interceptors/xConfig.interceptor';
import {AuthControllerProvider} from '@core/auth/auth.controller.provider';
import {GetConfigFacadeProvider} from '@features/app-config/presentation/facades/get-config/get-config.facade.provider';
import {ThemeAdapterProvider} from '@shared/infrastructure/theme/theme.adapter.provider';
import {xSocketInterceptor} from '@core/interceptors/xSocket.interceptor';
import {SpinnerProvider} from '@shared/infrastructure/spinner/spinner.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {SelectivePreloadStrategy} from '@shared/strategy/selective-preload.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withPreloading(SelectivePreloadStrategy)),
    provideHttpClient(withInterceptors([
      xTokenInterceptorFn,
      xConfigInterceptorFn,
      xSocketInterceptor
    ])),
    ThemeAdapterProvider,
    SpinnerProvider,
    LocalStorageAdapterProvider,
    NavigationAdapterProvider,
    ...GetConfigFacadeProvider,
    ...AuthControllerProvider,
  ]
};
